// Resolves the per-outcome stroke color map the chart hands to Liveline.
//
// Normal markets color each line by its outcome via the 16-hue palette. The
// winners-token chart (MOR-509) instead passes a single `uniformColor` so every
// line shares one brand color — `uniformColor` wins for every outcome when set.

/**
 * Build the `outcome.index → stroke color` map for the chart series.
 *
 * @param outcomes     Outcomes in render order (only `.index` is read).
 * @param paletteColors Per-outcome palette color (resolved literal), aligned by
 *                      position with `outcomes`. `undefined` ⇒ that outcome has
 *                      no palette color and is skipped (the caller's series
 *                      builder falls back to its own default).
 * @param uniformColor When set, EVERY outcome maps to this single color instead
 *                     of its palette entry. Used by the winners chart.
 */
export function buildStrokeByIndex(
  outcomes: ReadonlyArray<{ index: number }>,
  paletteColors: ReadonlyArray<string | undefined>,
  uniformColor: string | undefined,
): Record<number, string> {
  const map: Record<number, string> = {};
  for (let i = 0; i < outcomes.length; i++) {
    const outcome = outcomes[i];
    if (!outcome) continue;
    const color = uniformColor ?? paletteColors[i];
    if (color !== undefined) map[outcome.index] = color;
  }
  return map;
}
